import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Button,
  Card,
  Checkbox,
  Descriptions,
  Flex,
  Form,
  Input,
  Switch,
  Typography,
} from "antd";

import routes from "@/routes";

import EditIcon from "@/icons/EditIcon";

import { createForm, updateForm } from "@/api/requests";

const MainInfo = ({
  data,
  form,
  isNew,
  isDeleted,
  setPending,
  id,
  fetchData,
}) => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isEditingMain, setIsEditingMain] = useState(isNew);

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  const handleSave = async (values) => {
    setPending(true);
    setError(null);

    const payload = {
      ...values,
    };

    try {
      if (isNew) {
        const res = await createForm(payload);
        console.log(payload);

        const newId = res.uuid;

        navigate(routes.administration.requestSettings(newId));
        return;
      } else {
        await updateForm({ uuid: id, ...payload });
      }

      setIsEditingMain(false);
      fetchData();

      // navigate(routes.administration.systemSettings);
    } catch (error) {
      setError(error.message);
    } finally {
      setPending(false);
    }
  };
  return (
    <Card
      title={
        <Typography.Title level={4} className="no-margin">
          Основная информация
        </Typography.Title>
      }
      extra={
        !isEditingMain &&
        !isDeleted && (
          <Button
            type="text"
            icon={<EditIcon />}
            onClick={() => setIsEditingMain(true)}
          />
        )
      }
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ flex: "165px" }}
        wrapperCol={{ flex: 1 }}
        disabled={isDeleted || !isEditingMain}
        initialValues={{
          name: "",
          is_visible: false,
          enable_attachments: false,
          description: "",
          access_mode: "public",
        }}
      >
        {!isEditingMain || isDeleted ? (
          <Descriptions column={1}>
            <Descriptions.Item label="Название">{data?.name}</Descriptions.Item>

            <Descriptions.Item label="Описание">
              {data?.description}
            </Descriptions.Item>

            <Descriptions.Item label="Видимость">
              {data?.is_visible ? "Видимый" : "Скрытый"}
            </Descriptions.Item>

            <Descriptions.Item label="Прикрепление файлов">
              {data?.enable_attachments ? "Разрешено" : "Запрещено"}
            </Descriptions.Item>
          </Descriptions>
        ) : (
          <>
            <Form.Item
              label="Название типа заявки"
              name="name"
              rules={[{ required: true, message: "Введите название" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item label="Описание" name="description">
              <Input.TextArea rows={4} />
            </Form.Item>

            <Form.Item
              label="Видимость"
              name="is_visible"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item
              label="Прикрепление файлов"
              name="enable_attachments"
              valuePropName="checked"
            >
              <Checkbox>Разрешить прикрепление</Checkbox>
            </Form.Item>

            {!isDeleted && (
              <Flex gap={8} justify="end">
                {error && (
                  <div>
                    <Typography.Text type="danger">{error}</Typography.Text>
                  </div>
                )}
                {!isNew && (
                  <Button onClick={() => setIsEditingMain(false)}>
                    Отмена
                  </Button>
                )}
                <Button type="primary" onClick={onOk}>
                  {isNew ? "Создать" : "Сохранить"}
                </Button>
              </Flex>
            )}
          </>
        )}
      </Form>
    </Card>
  );
};

export default MainInfo;
